import { axios } from "@Root/API";

export const getAdminTeiStatuses = () => {
  return axios.get("all-teid-status");
};
